var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.permisisonsArray),function(permission){return _c('v-chip',{key:permission,staticClass:"mx-2",attrs:{"dense":"","small":"","color":"primary"}},[_vm._v(_vm._s(permission))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }